import { Component } from '@angular/core';

import { MetricService } from '../metric.service';
import { MetricBaseAbstract } from '../metric-base.abstract';

@Component({
    selector: 'app-gtag-metric',
    templateUrl: './gtag-metric.component.html',
    standalone: true
})
export class GtagMetricComponent extends MetricBaseAbstract {
  constructor(
    private metrica: MetricService
  ) {super()}

  protected override onRunMetric(codes: string[]): void {
    this.metrica.runGTM(codes);
  }
}
